export default __webpack_public_path__ + "static/media/cred-flow.e278bdec.png";